import { ZoomInOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react';
import WeatherChart from "../../../../components/WeatherChart";
import { openPopup2 } from "../../../../contexts/PopupContext";
import { MAP_ELEMENT } from "../../../../contexts/WorldMapContext/constants";
import { PoiService } from "../../../../util/services/poi";
import { showErrorResponse } from "../../../../util/varibles/global";
import styles from "../../Control/LeftControl/style.module.scss";

const initWeather = { weather: {}, typical_condition: 0 };
interface IProps {
    data: {
        id: string,
        name: string
        type: MAP_ELEMENT
    }
}

const Weather: React.FC<IProps> = ({ data }) => {
    const [{ loading, weather }, setWeather] = useState<{ loading: boolean, weather: { weather: any, typical_condition: number } }>({ loading: false, weather: initWeather })

    useEffect(() => {
        setWeather({ loading: true, weather: initWeather })
        PoiService.weather(data)
            .then(rs => {
                setWeather({ loading: false, weather: rs })
            })
            .catch(err => {
                showErrorResponse("Get weather failure", err)
                setWeather({ loading: false, weather: initWeather })
            })
    }, [data])

    const handleOpen = () => {
        openPopup2(<WeatherChart {...{ loading, weather, }} />, { modalProps: { title: `Weather for ${data.name}`, width: 800 } })
    }

    return <>
        <div className={styles.title}>
            <div>Weather info.</div>
            <div className={styles['zoom-in']} onClick={handleOpen} title='Zoom in'>
                <ZoomInOutlined />
            </div>
        </div>
        <div className={styles.body}>
            <WeatherChart {...{
                loading,
                weather,
                width: 395,
                height: !weather.weather || weather.weather.length === 0 ? 200 : 250
            }} />
        </div>
    </>
};

export default Weather;
